import React, { FunctionComponent } from "react";

import {
  PlainTextField,
  Text,
  useInputGroupState,
} from "@smartsuite/react-ui/lib";
import { PlainTextFieldProps } from "@smartsuite/react-ui/lib/components/forms/PlainTextField/PlainTextField";

export type TextFieldInputProps = PlainTextFieldProps;

export const TextFieldInput: FunctionComponent<TextFieldInputProps> = (
  props: TextFieldInputProps,
) => {
  const { state, onFocus, onBlur } = useInputGroupState();

  return (
    <PlainTextField
      {...props}
      state={state}
      active={state === "active"}
      renderLabel={renderFieldLabel}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
};

const renderFieldLabel = (name: string, isActive: boolean): JSX.Element => {
  return (
    <Text
      weight="medium"
      color={isActive ? "link" : "primary"}
      wrapMode="ellipsis"
    >
      {name}
    </Text>
  );
};
